export const exportMaintenanceToExcelService =
  (fetchData) => async (filters) => {
    try {
      const searchParams = new URLSearchParams(filters).toString();
      const response = await fetchData({
        url: "/api/v1/mantenimiento/export/excel?" + searchParams,
        responseType: "blob",
      });

      return response;
    } catch (error) {
      console.error("Error exporting maintenance to Excel:", error);
    }
  };
